// extracted by mini-css-extract-plugin
export default {"root":"TreeItem_root__TqXpc","write":"TreeItem_write__g5tgi"};